import { useEffect } from 'react';

/** Préfixe le titre de l'onglet le temps que le composant est monté. */
const usePageTitle = (title?: string | null): void => {
    useEffect(() => {
        const parts = document.title.split(' | ');
        const baseTitle = parts.length > 1 ? parts.slice(1).join(' | ') : document.title;
        document.title = title ? `${title} | ${baseTitle}` : baseTitle;
        return () => {
            document.title = baseTitle;
        };
    }, [title]);
};

export default usePageTitle;
